import { useState, useEffect } from 'react'
import Router from 'next/router'

import { toast } from 'react-toastify'

import { default as MultipleConsultationDesktop } from './MultipleConsultationDesktop'
import { default as MultipleConsultationMobile } from './MultipleConsultationMobile'
import { Loader } from '../Loader'
import { Row } from '../Grid'
import { Text } from '../Text'

import { checkIsMobile } from 'utils/helpers'
import { FilledInfo } from 'components/v2/Icons'
import { getCartBalance } from 'services/shoppingCart'
import { getProfile } from 'services/auth'
import { getProfessionalInfoBySlug } from 'services/professionalService'

const ScheduleConsultation = ({ professional, isModal, toggleModal }) => {
  const [isMobile, setIsMobile] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [consultationsInfo, setConsultationsInfo] = useState({})
  const [psychologistInfo, setPsychologistInfo] = useState({})

  const { contract, billing_account_id } = getProfile()

  useEffect(() => {
    setIsMobile(checkIsMobile(993))
    handleInitialValues()
  }, [])

  const handleInitialValues = async () => {
    const currentProfessional = professional || (await handleGetProfessional())

    if (currentProfessional) {
      const balance = await handleGetBalance()
      handleMountCartData(currentProfessional, balance)
      setIsLoading(false)
    }
  }

  const handleMountCartData = (professional, balance, benefit) => {
    try {
      const hasCredit = balance > 0 || contract?.balance > 0
      const clinics = handleClinics(professional)

      const consultationsData = {
        totalValue: 0,
        consultationAmount: 1,
        hasCredit: hasCredit
      }

      const psychologistInfo = {
        id: professional?.id,
        name: professional?.name,
        title: professional?.gender === 'F' ? 'Psicóloga:' : 'Psicólogo:',
        slug: professional?.slug,
        schedules: professional?.schedules,
        clinics: {
          virtual: clinics.virtualClinic,
          physical: clinics.physicalClinics,
          formatedPhysicalClinics: clinics.formatedPhysicalClinics
        }
      }

      setPsychologistInfo(psychologistInfo)
      setConsultationsInfo(consultationsData)
    } catch (error) {
      console.log(error)
    }
  }

  const getSlugOnStorage = () => {
    try {
      return typeof window !== 'undefined' && sessionStorage.getItem('slug')
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetProfessional = async () => {
    try {
      const storedSlug = getSlugOnStorage()
      const { data, status } = await getProfessionalInfoBySlug(storedSlug)
      if (status === 204) {
        Router.replace('/psicologo-indisponivel')
        return
      }
      return data
    } catch (error) {
      console.log(error)
      toast.error('Ocorreu um erro ao buscar dados de seu psicólogo, tente novamente mais tarde.')
    }
  }

  const handleGetBalance = async () => {
    try {
      const { data } = await getCartBalance(billing_account_id)
      return data.content.balance
    } catch (error) {
      toast.error('Ocorreu um erro ao buscar seu saldo, tente novamente mais tarde.')
      console.log(error)
    }
  }

  const handleClinics = professional => {
    const virtualClinic = professional.schedules.find(clinic => !clinic.location)
    const physicalClinics = professional.schedules.filter(clinic => clinic.location)
    const formatedPhysicalClinics = []

    physicalClinics.map(clinic => {
      formatedPhysicalClinics.push({ label: clinic?.prof_address, value: clinic?.id })
    })

    const clinics = {
      virtualClinic,
      physicalClinics,
      formatedPhysicalClinics
    }

    return clinics
  }

  if (isLoading)
    return (
      <Row width='100%' height='583px' justifyContent='center' alignItems='center'>
        <Loader size={50} />
      </Row>
    )

  return (
    <>
      {isMobile ? (
        <MultipleConsultationMobile
          consultationsInfo={consultationsInfo}
          psychologistInfo={psychologistInfo}
          isModal={isModal}
          toggleModal={toggleModal}
        />
      ) : (
        <MultipleConsultationDesktop
          consultationsInfo={consultationsInfo}
          psychologistInfo={psychologistInfo}
          isModal={isModal}
          toggleModal={toggleModal}
        />
      )}
    </>
  )
}

export { ScheduleConsultation }
